enum VALIDATION_ENUM {
  REQUIRED = "To pole jest wymagane",
  EMPTY_SPACE = "To pole nie może zawierać spacji",
  WRONG_EMAIL = "Niepoprawny adres email",
  MIN_8 = "Minimum 8 znaków",
  CONFIRM_PASSWORD = "Hasła muszą być takie same",
  CANNOT_START_AND_END_WITH_SPACE = "Nie może zaczynać się ani kończyć spacją",
  MIN6 = "Minimum 6 znaków",
  MIN3 = "Minimum 3 znaki",
  MIN1 = "Minimum 1 znak",
  MIN_2 = "Minimum 2 znaki",
  NUMBER = "To pole może zawierać wyłącznie cyfry",
  PASSWORD_MUST_BE_DIFFERENT = "Nowe hasło musi być różne od starego",
  POST_PUBLISHED = "Status 'opublikowana' może być ustawiony tylko dla wpisów z przeszłości",
  POST_PLANNED = "Status 'zaplanowana' może być ustawiony tylko dla wpisów z przyszłości",
  MAX_50 = "Maksymalnie 50 znaków",
  MIN_1 = "Wartość nie może być mniejsza niż 1",
  MIN_0_1 = "Wartość nie może być mniejsza niż 0.01",
  MIN_0_1_SHARES = "Wartość nie może być mniejsza niż 0.01",
  INVALID_PHONE_FORMAT = "Niepoprawny format numeru telefonu",
  CANNOT_START_WITH_0 = "To pole nie może zaczynać się od 0",
  PESEL = "Nieprawidłowy PESEL",
  FILE_REQUIRED = "Plik jest wymagany",
  POSTAL_CODE = 'Kod pocztowy musi mieć format XX-XXX (np. 00-001)',
  MAX_100 = "Maksymalnie 100 znaków",
  MAX_6 = "Maksymalnie 6 znaków",
  MAX_PARITY = "Maksymalny parytet wymiany to 1 000 000",
  TRANSFORMATION_SHARES_LIMIT = "Wynik przeliczenia przekracza dopuszczalną liczbę akcji. Zmniejsz parytet wymiany.",
  MAX_200 = "Maksymalnie 200 znaków"
}

export default VALIDATION_ENUM;
